import { Button, Drawer, Empty, Flex, Divider, Text } from "../../components";
import {
  useCartItem,
  useCheckoutGate,
  useDevice,
  useNavigate,
  useSearchParams,
} from "../../hooks";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useCartStore } from "../../stores";
import CheckoutGateAlert from "../checkoutGateAlert";
import Footer from "./footer";
import Item from "./item";
import Suggestions from "./suggestions";
import React from "react";

const Cart = (props = {}) => {
  const { searchParams, removeParams } = useSearchParams({ cart: false });
  const { blocked } = useCheckoutGate();
  const cartStore = useCartStore();
  const { remove: removeItem } = useCartItem();
  const { isMobile } = useDevice();
  const { navigate } = useNavigate();

  const onClose = () => removeParams("cart");

  const renderFooter = () => (
    <div className="p-10">
      {blocked ? (
        <CheckoutGateAlert />
      ) : (
        <Button
          color="base"
          title="Checkout"
          className="w-100"
          loading={cartStore.calculatingQuote}
          onClick={() => {
            onClose();
            navigate("/checkout");
          }}
        />
      )}
    </div>
  );

  return (
    <Drawer
      open={!!searchParams.cart}
      height={"90vh"}
      width={"400px"}
      onClose={onClose}
      closable={false}
      title={`Your Cart (${cartStore.totalItemsInCart || 0})`}
      placement={isMobile ? "bottom" : "right"}
      classNames={{
        body: "flex flex-col gap-[30px]",
        footer: "!border-t-0 !bg-transparent",
      }}
      footer={!!cartStore.items.length && renderFooter()}
      extra={
        <Text
          level={4}
          onClick={onClose}
          color="secondary"
          className="cursor-pointer"
          children={<CloseOutlined />}
        />
      }
      {...props}
    >
      {!cartStore.items.length ? (
        <Empty description="Your cart feels lonely!" />
      ) : (
        <>
          <Flex flex={1} vertical gap={"2rem"}>
            {React.Children.toArray(
              cartStore?.items.map((item, index) => (
                <>
                  {!!index && <Divider className="m-0-v" />}
                  <Item
                    {...item}
                    onAdd={() => cartStore.add(item)}
                    onRemove={() => removeItem(item)}
                    onDelete={() => removeItem(item, true)}
                  />
                </>
              )),
            )}
            <Button
              outlined
              color="base"
              onClick={() => {
                onClose();
                navigate("/");
              }}
              title="Add more items"
              className="mt-[20px]"
              icon={<PlusOutlined />}
            />
          </Flex>
          <Suggestions />
          <Footer />
        </>
      )}
    </Drawer>
  );
};

Cart.Item = Item;
Cart.Footer = Footer;

export default Cart;
